import { createStore } from 'vuex';
import { modules } from '@/store/module/modules.js';

export const store = createStore({
	modules
});
